"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSmartSupply = void 0;
/*
  UK: Smart if raw meter type begins with S1/S2
 */
var isSmartSupply = function (rawMeterType) {
    var meterType = rawMeterType.toLowerCase();
    return (meterType.startsWith('s1') ||
        meterType.startsWith('s2') ||
        meterType.startsWith('2'));
};
exports.isSmartSupply = isSmartSupply;
